export default __webpack_public_path__ + "static/media/red.107f30c1.png";